import { Box, Stack } from '@mui/material';
import type { GroupedFeaturedEventsCarouselProps } from '../../../molecules/grouped-featured/GroupedFeaturedEventsCarousel';
import { getSortedFeaturedEventItems, toPublishedEventListItem } from '../../../../hooks/useGroupedFeaturedContent';
import Heading from './Heading';
import EventCard from './EventCard';

const styles = {
  container: {
    borderTop: '1px solid',
    borderColor: 'info.600',
  },
  row: {
    overflowX: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
    backgroundColor: 'neutral.600',
  },
  card: {
    flexShrink: 0,
    width: 200,
    borderRight: 1,
    borderColor: 'primary.main',
  },
};

const GroupedFeaturedEventsCarousel = ({ title, groups, link }: GroupedFeaturedEventsCarouselProps) => {
  const items = getSortedFeaturedEventItems(groups);

  if (!items.length) {
    return null;
  }

  return (
    <Box sx={styles.container}>
      <Heading to={link}>{title}</Heading>
      <Stack sx={styles.row} direction='row'>
        {items.map(({ group, event }) => (
          <Box key={event.id} sx={styles.card}>
            <EventCard
              event={toPublishedEventListItem(group, event)}
              topMarketTypes={group.topMarketTypes}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default GroupedFeaturedEventsCarousel;
